import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Seyitnizam Mahallesi Halı Yıkama",
    path: "/zeytinburnu/seyitnizam-hali-yikama",
    description:
      "Seyitnizam Mahallesi’nde halılarınız modern makinelerde yıkanır, steril şekilde paketlenip adresinize teslim edilir."
  },
  {
    label: "Merkezefendi Halı Yıkama",
    path: "/zeytinburnu/merkezefendi-hali-yikama",
    description:
      "Merkezefendi Mahallesi’nde organik temizlik ürünleri ile hijyenik halı yıkama hizmeti sunuyoruz."
  },
  {
    label: "Nuripaşa Mahallesi Halı Yıkama",
    path: "/zeytinburnu/nuripasa-hali-yikama",
    description:
      "Nuripaşa Mahallesi’nde halı yıkama işlemleri hızlı servis, garantili temizlik ve ücretsiz teslimatla gerçekleştirilir."
  },
  {
    label: "Telsiz Mahallesi Halı Yıkama",
    path: "/zeytinburnu/telsiz-hali-yikama",
    description:
      "Telsiz Mahallesi’nde halılarınız tam otomatik sistemlerde derinlemesine temizlenir ve aynı gün teslim edilir."
  },
  {
    label: "Beştelsiz Mahallesi Halı Yıkama",
    path: "/zeytinburnu/bestelsiz-hali-yikama",
    description:
      "Beştelsiz bölgesinde profesyonel ekip ve son teknolojiyle halı yıkama hizmeti sunmaktayız."
  },
  {
    label: "Veliefendi Mahallesi Halı Yıkama",
    path: "/zeytinburnu/veliefendi-hali-yikama",
    description:
      "Veliefendi Mahallesi'nde halılarınız çevre dostu deterjanlarla sağlığınıza zarar vermeden yıkanır."
  },
  {
    label: "Çırpıcı Mahallesi Halı Yıkama",
    path: "/zeytinburnu/cirpici-hali-yikama",
    description:
      "Çırpıcı Mahallesi’nde bireysel ve ticari halı yıkama taleplerinizi hızlı ve güvenilir şekilde karşılıyoruz."
  }
];

const ZeytinburnuSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">ZEYTİNBURNU SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ZeytinburnuSidebar;
